import { DatatableSort } from "@/model/dto/datatable-sort"
import { Filter } from "@/model/dto/filter"
import {AxiosPromise} from "axios"
import { plainToClass } from "class-transformer"
import {EntityService} from "../entity-service"
import {Page} from "@/model/dto/page"
import ActivityHistoryLog from "@/model/entity/activity-history/activity-history-log"
import ActivityHistory from "@/model/entity/activity-history/activity-history"
import _ from "lodash"

type Construct = new (...args: any) => any

class ExportLogService extends EntityService<ActivityHistoryLog> {
  constructor(cls: Construct, masterData: ActivityHistory) {
    super("activity_history", cls)
    this.masterData = masterData
  }

  private masterData: ActivityHistory

  public getPage(
    page: number,
    rows: number,
    filters: Filter[],
    sort?: DatatableSort
  ): AxiosPromise<Page<ActivityHistoryLog>> {
    return this.$http.post(
      `${this.path}/findDetails${this.buildQueryParams(filters, page - 1, rows, sort)}`,
      this.masterData
      ).then(response => {
        response.data.content = plainToClass(this.classType, response.data.content)
        return response
      })
  }

  public buildQueryParams(filters: Filter[], page?: number, rows?: number, sort?: DatatableSort) {
    let query = "?"

    if (exists(page)) {
      query = `${query}page=${page}&`
    }

    if (exists(rows)) {
      query = `${query}rows=${rows}&`
    }

    filters.forEach(filter => {
      const trimmed = trimDeep(filter)
      query = `${query}${trimmed.field}=${trimmed.value}&`
    })

    return query
  }

  public exportCsv(addionalParams: Map<string, string> | null = null) {
    let exportUrl = _.get(this.classType, "exportUrl")
    if (!exportUrl) {
      throw new Error("no exportUrl specified")
    }

    if (addionalParams) {
      exportUrl = `${exportUrl}?`
      addionalParams.forEach((value, key) => {
        exportUrl = `${exportUrl}&${key}=${value}`
      })
    }

    return this.$http.get(exportUrl).then((response) => {
      const contentType = response.headers["content-type"]
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      const blob = new Blob([response.data], { type: contentType })

      return {
        blob,
        filename
      }
    })
  }
}

interface IExportLogService extends EntityService<ActivityHistoryLog> {
}

export {
  IExportLogService,
  ExportLogService
}
